import React, { Component } from 'react'
import MenuSider from '../../../../components/MenuSider'
import { Bar } from 'react-chartjs-2';
import { Odata_Url, Constants, Odata_2_Url } from '../../../../Constants/Constants'
import { Select, Spin } from 'antd';
import './Myself.css'
import 'chartjs-plugin-labels';
import IntlMessages from '../../../../util/IntlMessages';

const Option = Select.Option;


const Initial_Count_Nearmiss = 0
const Initial_Count_Unsafe_Killer = 0
const Initial_Count_Observation_All = 0

export default class Myself extends Component {

    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this);
        var year_now_ = new Date().getFullYear()

        this.state = {
            chartData: {},
            unsafe_killer: Initial_Count_Unsafe_Killer,
            nearmiss: Initial_Count_Nearmiss,
            observation_All: Initial_Count_Observation_All,
            data1: 1,
            year_now: year_now_,
            dataObservation: [],
            onLoading: false,
            barOptions: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            autoSkip: false,
                            autoSkipPadding: 20,
                            maxRotation: 90,
                            minRotation: 90
                        },
                        maxBarLength: 2,
                        maxBarThinckness: 8,
                    }]
                },
                plugins: {
                    labels: {
                        render: 'value'
                    }
                }
            },
        }
    }


    componentWillMount() {
        const state = JSON.parse(window.localStorage.getItem('state'))
        const userid = state.authen.UserID
        // this.props.set_DefalutmonthPicker()  

        const axios = require('axios');
        var year_now = new Date().getFullYear()
        this.setState({ onLoading: true });
        var Token
        axios.get(Constants.BASE_URL + 'auth/token')
            .then((response) => {
                Token = response.data
                // console.log(Token)

                axios.get(
                    Odata_Url + `OObservation_Transaction?$filter=IsActived eq true and IsDeleted eq false and UserID eq ` + userid,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        var data = []
                        var Count_Observation =
                        {
                            JAN: 0, FEB: 0, MAR: 0, APR: 0,
                            MAY: 0, JUN: 0, JUL: 0, AUG: 0,
                            SEPT: 0, OCT: 0, NOV: 0, DEC: 0
                        }
                        var Count_Nearmiss = Initial_Count_Nearmiss
                        var Count_Unsafe_Killer = Initial_Count_Unsafe_Killer
                        var Count_Observation_All = Initial_Count_Observation_All

                        response.data.value.forEach(function (element) {
                            // console.log(element.CreateDate.slice(5, 7))
                            if (element.CreateDate.slice(0, 4) === year_now.toString()) {
                                switch (element.CreateDate.slice(5, 7)) {
                                    case "01": Count_Observation.JAN++;
                                        break;

                                    case "02": Count_Observation.FEB++;
                                        break;
                                    case "03": Count_Observation.MAR++;
                                        break;
                                    case "04": Count_Observation.APR++;
                                        break;
                                    case "05": Count_Observation.MAY++;
                                        break;
                                    case "06": Count_Observation.JUN++;
                                        break;
                                    case "07": Count_Observation.JUL++;
                                        break;
                                    case "08": Count_Observation.AUG++;
                                        break;
                                    case "09": Count_Observation.SEPT++;
                                        break;
                                    case "10": Count_Observation.OCT++;
                                        break;
                                    case "11": Count_Observation.NOV++;
                                        break;
                                    case "12": Count_Observation.DEC++;
                                        break;
                                    default:
                                        break;
                                }
                                Count_Observation_All++
                                if (element.Nearmiss) {
                                    Count_Nearmiss++
                                }
                                if (element.Unsafe_detail_corrective_action !== "" || element.Unsafe_detail_next_action !== "") {
                                    Count_Unsafe_Killer++
                                }
                            }
                            // data variable is all data of user
                            data.push(element)
                        });
                        //window.localStorage.setItem('Observation_Transaction', JSON.stringify(data));
                        this.setState({
                            dataObservation: data,
                            unsafe_killer: Count_Unsafe_Killer,
                            nearmiss: Count_Nearmiss,
                            observation_All: Count_Observation_All
                        })
                        this.set_data(Count_Observation);
                        this.setState({ onLoading: false });
                    },
                        (error) => {
                            console.log(error)
                            this.setState({ onLoading: false });
                        });
            },
                (error) => {
                    this.setState({ onLoading: false });
                    console.log(error)
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                });
    }

    set_data(Count_Observation) {
        var x = Count_Observation

        // console.log(x)
        this.setState({
            chartdata: {
                labels: ['JAN', 'FEB', 'MAR', 'APIL', 'MAY', 'JUNE', 'JULY', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                datasets: [
                    {
                        label: `My Observation Checklist in ${this.state.year_now}`,
                        backgroundColor: 'rgba(255,99,132,0.2)',
                        borderColor: 'rgba(255,99,132,1)',
                        borderWidth: 1,
                        hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                        hoverBorderColor: 'rgba(255,99,132,1)',
                        data: [x.JAN, x.FEB, x.MAR, x.APR, x.MAY, x.JUN, x.JUL, x.AUG, x.SEPT, x.OCT, x.NOV, x.DEC]
                    }
                ]
            }

        })
    }
    handleChange(value) {
        // console.log(`selected ${value}`)
        var all_data = this.state.dataObservation
        this.setState({ onLoading: true });

        var data_in_year_change =
        {
            JAN: 0, FEB: 0, MAR: 0, APR: 0,
            MAY: 0, JUN: 0, JUL: 0, AUG: 0,
            SEPT: 0, OCT: 0, NOV: 0, DEC: 0
        }

        var Count_Nearmiss = Initial_Count_Nearmiss
        var Count_Unsafe_Killer = Initial_Count_Unsafe_Killer
        var Count_Observation_All = Initial_Count_Observation_All

        all_data.map((l, i) => {
            if (l.CreateDate.slice(0, 4) === value.toString()) {
                switch (l.CreateDate.slice(5, 7)) {
                    case "01": data_in_year_change.JAN++;
                        break;
                    case "02": data_in_year_change.FEB++;
                        break;
                    case "03": data_in_year_change.MAR++;
                        break;
                    case "04": data_in_year_change.APR++;
                        break;
                    case "05": data_in_year_change.MAY++;
                        break;
                    case "06": data_in_year_change.JUN++;
                        break;
                    case "07": data_in_year_change.JUL++;
                        break;
                    case "08": data_in_year_change.AUG++;
                        break;
                    case "09": data_in_year_change.SEPT++;
                        break;
                    case "10": data_in_year_change.OCT++;
                        break;
                    case "11": data_in_year_change.NOV++;
                        break;
                    case "12": data_in_year_change.DEC++;
                        break;
                    default:
                        break;
                }
                Count_Observation_All++
                if (l.Nearmiss) {
                    Count_Nearmiss++
                }
                if (l.Unsafe_detail_corrective_action !== "" || l.Unsafe_detail_next_action !== "") {
                    Count_Unsafe_Killer++
                }
            }
        })


        var x = data_in_year_change
        // console.log(x)
        this.setState({
            chartdata: {
                labels: ['JAN', 'FEB', 'MAR', 'APIL', 'MAY', 'JUNE', 'JULY', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                datasets: [
                    {
                        label: `My Observation Checklist in ${value}`,
                        backgroundColor: 'rgba(255,99,132,0.2)',
                        borderColor: 'rgba(255,99,132,1)',
                        borderWidth: 1,
                        hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                        hoverBorderColor: 'rgba(255,99,132,1)',
                        data: [x.JAN, x.FEB, x.MAR, x.APR, x.MAY, x.JUN, x.JUL, x.AUG, x.SEPT, x.OCT, x.NOV, x.DEC]
                    }
                ]
            },
            nearmiss: Count_Nearmiss,
            unsafe_killer: Count_Unsafe_Killer,
            observation_All: Count_Observation_All
        })
        this.setState({ onLoading: false });
    }
    render() {
        var min = "2018"
        var max = new Date().getFullYear()
        var options = []
        for (var i = min; i <= max; i++) {
            options.push(
                <Option value={i} key={"selected_year" + i}>{i}</Option>
            )
        }
        const { unsafe_killer, nearmiss, observation_All, chartdata } = this.state
        return (
            <div>
                <Spin spinning={this.state.onLoading} size="large" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} tip={<IntlMessages id='Loading' />}>

                    <MenuSider title={<IntlMessages id='menu.dashboard_myself' />}>
                        <div style={{ width: "100%", padding: "10px 20px 0 20px", textAlign: "center" }}>
                            <Select
                                style={{ width: 120 }}
                                placeholder="Select a year"
                                onChange={this.handleChange}
                                defaultValue={max}
                            >
                                {options}
                            </Select>
                        </div>

                        <div className="Chart-bar" style={{ paddingTop: "15px" }}>
                            <Bar
                                ref="chart"
                                data={chartdata}
                                options={{
                                    title: {
                                        text: 'Largest Cities In ',
                                        fontSize: 25
                                    },
                                    legend: {
                                        display: "Massachusetts",
                                        position: "top"
                                    },
                                    plugins: {
                                        labels: {
                                            render: 'value'
                                        }
                                    },
                                    scales: {
                                        yAxes: [{
                                            ticks: {
                                                beginAtZero: true,
                                            }
                                        }],
                                        xAxes: [{
                                            ticks: {
                                                autoSkip: false,
                                                autoSkipPadding: 20,
                                                maxRotation: 90,
                                                minRotation: 90
                                            },
                                            maxBarLength: 2,
                                            maxBarThinckness: 8,
                                        }]
                                    },

                                    // maintainAspectRatio: false  
                                }}
                            />
                        </div>
                        <div style={{ width: "100%" }}>
                            <div className="Observation_All" style={{ width: "33%", display: "inline-block", textAlign: "center" }}>
                                <div>
                                    <IntlMessages id='Dashboard.Observation' />
                                </div>
                                <div style={{ fontSize: "25px" }}>
                                    {observation_All}
                                </div>
                            </div>
                            <div className="Unsefe-killer" style={{ width: "33%", display: "inline-block", textAlign: "center" }}>
                                <div>
                                    <IntlMessages id='Dashboard.UnsafeKiller' />
                                </div>
                                <div style={{ fontSize: "25px" }}>
                                    {unsafe_killer}
                                </div>
                            </div>
                            <div className="Near-miss" style={{ width: "34%", display: "inline-block", textAlign: "center" }}>
                                <div>
                                    <IntlMessages id='Dashboard.NearMiss' />
                                </div>
                                <div style={{ fontSize: "25px" }}>
                                    {nearmiss}
                                </div>
                            </div>
                        </div>
                    </MenuSider>
                </Spin>
            </div>
        )
    }
}